import 'regenerator-runtime/runtime';

const loadAdminScript = async () => {
  await import('./admin/auth/signin');
  await import('./admin/materials/regist');
  await import('./admin/materials/regist-excel');
  await import('./admin/materials/crawling');
  await import('./admin/materials/list');
  await import('./admin/example/live-scene-regist');
  await import('./admin/example/live-scene-list');
  await import('./admin/example/regist');
  await import('./admin/example/list');
  await import('./admin/task/manager/list');
  await import('./admin/task/manager/modify');
  await import('./admin/task/manager/regist');
  await import('./admin/product/list');
  await import('./admin/product/modify');
  await import('./admin/product/price-modify');
  await import('./admin/reading-contents/category');
  await import('./admin/reading-contents/content-list');
  await import('./admin/reading-contents/content-edit');
  await import('./admin/reading-contents/reading-gen-export');
  await import('./admin/real-price/list');
  await import('./admin/real-price/write');
  await import('./admin/google-drive-sites/list');
  await import('./admin/google-drive-sites/detail');
}

const loadCsScript = async () => {
  await import('./cs/index');
  await import('./cs/signin');
  await import('./cs/common');
  await import('./cs/application/list');
  await import('./cs/application/detail-common');
  await import('./cs/application/overview-memo-history-toggle');
  await import('./cs/application/detail-estimation-v3');
  await import('./cs/application/detail-payment');
  await import('./cs/application/detail-materials');
  await import('./cs/application/detail-task-manager-assign');
  await import('./cs/application/detail-alimtalk');
  await import('./cs/application/detail-custom-estimation');
  await import('./cs/application/attached-images');
  await import('./cs/application/site-manage-list');
  await import('./cs/calendar');
  await import('./cs/estimation-v3-template');
}

const loadMypageScript = async () => {
  await import('./mypage/common-script');
  await import('./mypage/index');
  await import('./mypage/signin');
  await import('./mypage/my-estimation');
  await import('./mypage/my-estimation-v3');
  await import('./mypage/contract-signing');
  await import('./mypage/materials-preview');
  await import('./mypage/materials-select');
  await import('./mypage/defect-repair');
  await import('./mypage/construction-info-guide');
}

const loadFrontScript = async () => {
  await import('./front/home');
  await import('./front/common/index');
  await import('./front/large-scale-inquiry');
  await import('./front/estimation/floor');
  await import('./front/estimation/papering');
  await import('./front/estimation/molding');
  await import('./front/estimation/window');
  await import('./front/estimation/sink');
  await import('./front/estimation/light');
  await import('./front/estimation/firm');
  await import('./front/estimation/door');
  await import('./front/estimation/bathroom');
  await import('./front/estimation/common');
  await import('./front/estimation/packages/common');
  await import('./front/estimation/packages/monthlyrent');
  await import('./front/materials/list');
  await import('./front/materials/detail');
  await import('./front/example/list');
  await import('./front/example/detail');
  await import('./front/example/scene-list');
  await import('./front/real-price/list');
  await import('./front/real-price/detail');
  await import('./front/service-center/faq');
  await import('./front/reading-contents/list');
  await import('./front/reading-contents/detail');
  await import('./front/etc-payment');
  await import('./front/consulting');
  
  // construction-info 페이지인 경우에만 로드
  if (document.getElementById('front-task-manager-construction-info')) {
    await import(/* webpackChunkName: "src_assets_js_front_construction-info" */ './front/construction-info');
  }
}

(async () => {

  // path를 확인하여 어드민/cs/프론트 구분
  let regExp = new RegExp("^\/(admin|cs|mypage)\/?");
  let result = regExp.exec(window.location.pathname);
  if (window.location.pathname == '/' || !result?.[1]) {
    await loadFrontScript();
    return;
  }
  // 스크립트 동적로드
  switch (result[1]) {
    case 'admin':
      await loadAdminScript();
      break;
    case 'cs':
      await loadCsScript();
      break;
    case 'mypage':
      await loadMypageScript();
      break;
    default:
      await loadFrontScript();
      break;
  }
})();